const STORAGE_KEY = 'ww_attribution';

export interface Attribution {
  utm_source: string;
  utm_medium: string;
  utm_campaign: string;
  referrer: string;
  landing_page: string;
}

const EMPTY: Attribution = { utm_source: '', utm_medium: '', utm_campaign: '', referrer: '', landing_page: '' };

// Captures first-touch acquisition data once per browser session (same
// pattern as analyticsService.ts's getSessionId — sessionStorage, written
// once, read many times). Call on app boot; a later navigation within the
// same tab never overwrites the original values, so this reflects how the
// user actually arrived, not their most recent internal page.
export function captureAttribution(): void {
  try {
    if (sessionStorage.getItem(STORAGE_KEY)) return;
    const params = new URLSearchParams(window.location.search);
    const attribution: Attribution = {
      utm_source: params.get('utm_source') ?? '',
      utm_medium: params.get('utm_medium') ?? '',
      utm_campaign: params.get('utm_campaign') ?? '',
      referrer: document.referrer ?? '',
      landing_page: window.location.pathname,
    };
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(attribution));
  } catch {
    // sessionStorage unavailable (private mode, etc.) — attribution is best-effort only.
  }
}

export function getAttribution(): Attribution {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    return raw ? { ...EMPTY, ...JSON.parse(raw) } : EMPTY;
  } catch {
    return EMPTY;
  }
}
